import React from "react";
import gif from "../../images/loading.gif";

const LoadingBar = () => {
  return (
    <div
      style={{
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <img src={gif} alt={""} style={{ width: "100%" }}></img>
      <span
        style={{
          position: "absolute",
          left: "50%",
          bottom: -15,
          transform: "translate(-50%, -50%)",
        }}
      >
        Laden...
      </span>
    </div>
  );
};

export default LoadingBar;
